import * as types from '../constants/ActionTypes';

export const preserveQueryParams = (queryParams) => ({
  type: types.RECEIVE_QUERY_PARAMS,
  payload: queryParams,
});

export const fetchQueryParams = (queryParams) => (dispatch) => {
  dispatch(preserveQueryParams(queryParams));
};
